(() => {
  if (window.__airgomixMobilePredictiveSearch) return;
  window.__airgomixMobilePredictiveSearch = true;

  const MOBILE_QUERY = '(max-width: 699px)';
  const INPUT_SELECTOR = '.airgomix-mobile-search-input';
  const RESULT_CLASS = 'airgomix-mobile-search-results';
  const MIN_CHARS = 2;
  const DEBOUNCE = 160;
  let timer = null;
  let controller = null;

  const style = document.createElement('style');
  style.textContent = `
    @media screen and (max-width: 699px) {
      .shopify-section--header .header,
      .shopify-section--header .header__search-link { overflow: visible !important; }
      .shopify-section--header .header__search-link { z-index: 30 !important; }
      .${RESULT_CLASS} {
        position: absolute;
        top: 56px;
        left: 0;
        right: 0;
        z-index: 50;
        max-height: min(68vh, 520px);
        overflow: auto;
        overscroll-behavior: contain;
        padding: 14px;
        background: #fff;
        color: #001B3D;
        border: 1px solid rgba(0, 27, 61, .10);
        border-radius: 16px;
        box-shadow: 0 16px 42px rgba(0, 27, 61, .16);
        -webkit-overflow-scrolling: touch;
      }
      .${RESULT_CLASS}[hidden] { display: none !important; }
      .${RESULT_CLASS} .predictive-search__results,
      .${RESULT_CLASS} .predictive-search__no-results { width: 100%; }
      .${RESULT_CLASS} .predictive-search__tabs { display: block; }
      .${RESULT_CLASS} .predictive-search__tab-item { min-width: 0; }
      .${RESULT_CLASS} img { border-radius: 8px; }
      .${RESULT_CLASS} .button { min-height: 44px !important; }
    }
  `;
  document.head.appendChild(style);

  function ensureResults(input) {
    const form = input.closest('form');
    const item = input.closest('.header__search-link');
    if (!form || !item) return null;

    if (!form.id) form.id = 'airgomix-mobile-search-form';

    let results = item.querySelector(`.${RESULT_CLASS}`);
    if (!results) {
      results = document.createElement('div');
      results.className = RESULT_CLASS;
      results.id = 'airgomix-mobile-search-results';
      results.hidden = true;
      results.setAttribute('role', 'region');
      results.setAttribute('aria-label', 'Suchvorschläge');
      results.setAttribute('aria-live', 'polite');
      form.insertAdjacentElement('afterend', results);
    }

    input.setAttribute('aria-controls', results.id);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', results.hidden ? 'false' : 'true');
    return { form, results };
  }

  function closeResults(input) {
    const item = input?.closest?.('.header__search-link');
    const results = item?.querySelector?.(`.${RESULT_CLASS}`);
    if (results) results.hidden = true;
    if (input) input.setAttribute('aria-expanded', 'false');
  }

  async function loadSuggestions(input) {
    if (!window.matchMedia(MOBILE_QUERY).matches || !document.contains(input)) return;

    const query = input.value.trim();
    const ui = ensureResults(input);
    if (!ui) return;

    if (query.length < MIN_CHARS) {
      controller?.abort();
      ui.results.innerHTML = '';
      closeResults(input);
      return;
    }

    controller?.abort();
    controller = new AbortController();

    try {
      const root = window.Shopify?.routes?.root || '/';
      const params = new URLSearchParams({
        q: query,
        section_id: 'predictive-search',
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last'
      });

      const response = await fetch(`${root}search/suggest?${params.toString()}`, {
        signal: controller.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const source = doc.querySelector('.predictive-search__results, .predictive-search__no-results');

      if (!source || input.value.trim() !== query) {
        closeResults(input);
        return;
      }

      ui.results.innerHTML = source.outerHTML;
      ui.results.querySelectorAll('[form="predictive-search-form"]').forEach((el) => {
        el.setAttribute('form', ui.form.id);
      });
      ui.results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('[Airgomix predictive search]', error);
        closeResults(input);
      }
    }
  }

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.(INPUT_SELECTOR);
    if (!input) return;
    clearTimeout(timer);
    timer = window.setTimeout(() => loadSuggestions(input), DEBOUNCE);
  });

  document.addEventListener('focusin', (event) => {
    const input = event.target.closest?.(INPUT_SELECTOR);
    if (!input) return;
    const ui = ensureResults(input);
    if (ui && input.value.trim().length >= MIN_CHARS && ui.results.innerHTML.trim()) {
      ui.results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
  });

  document.addEventListener('keydown', (event) => {
    const input = event.target.closest?.(INPUT_SELECTOR);
    if (!input || event.key !== 'Escape') return;
    closeResults(input);
    input.blur();
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll(INPUT_SELECTOR).forEach((input) => {
      if (!input.closest('.header__search-link')?.contains(event.target)) closeResults(input);
    });
  });

  document.addEventListener('submit', (event) => {
    if (event.target.matches?.('.airgomix-mobile-search-form')) {
      const input = event.target.querySelector(INPUT_SELECTOR);
      closeResults(input);
    }
  });

  window.matchMedia(MOBILE_QUERY).addEventListener?.('change', (event) => {
    if (!event.matches) document.querySelectorAll(INPUT_SELECTOR).forEach(closeResults);
  });
})();
